/* unplugin-vue-components disabled */import script from "./mg-drop-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-drop-panel.vue?vue&type=script&setup=true&lang=js"

import "./mg-drop-panel.vue?vue&type=style&index=0&id=7073c218&lang=less"

const __exports__ = script;

export default __exports__